export default (isOpen: boolean, wrapperHeight: number) => ({
  isOpen: false,
  wrapperHeight,

  init() {
    this.wrapperHeight = (this as any).$refs.wrapper.offsetHeight
  },

  toggle() {
    this.isOpen = !this.isOpen
  },

  close() {
    this.isOpen = false
  },
})
